import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import BrandLogo from "@/components/BrandLogo";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(form.email, form.password);
      toast.success(`Welcome back, ${u.name?.split(' ')[0]}!`);
      const to = loc.state?.from || (u.role === "customer" ? "/account" : "/admin");
      navigate(to);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6] px-4" data-testid="login-page">
      <div className="w-full max-w-md mart-card p-8">
        <div className="flex justify-center mb-5">
          <div className="w-20 h-20 rounded-full bg-[#050505] flex items-center justify-center">
            <BrandLogo type="auth" size="md" showText={false} />
          </div>
        </div>
        <h1 className="font-heading text-3xl text-[#1A2421] text-center">Welcome back</h1>
        <p className="text-center text-[#5C6B64] text-sm mb-5">Sign in to your Maharlika account</p>
        <form onSubmit={submit} className="space-y-3">
          <input required type="email" placeholder="Email" data-testid="login-email" className="w-full border border-[#8A9A86]/40 rounded px-4 py-3" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})}/>
          <input required type="password" placeholder="Password" data-testid="login-password" className="w-full border border-[#8A9A86]/40 rounded px-4 py-3" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})}/>
          <button data-testid="login-submit" disabled={loading} className="btn-mart w-full py-3">{loading ? "Signing in..." : "Sign in"}</button>
        </form>
        <p className="text-sm text-[#5C6B64] mt-4 text-center">New here? <Link to="/register" data-testid="login-to-register" className="text-[#2C4A3B] font-semibold">Create account</Link></p>
      </div>
    </div>
  );
}
